import React from 'react';
import {Avatar, Box, Tooltip, Typography} from '@material-ui/core';
import {useTheme} from '@material-ui/core/styles';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import {normalizePanelChangeActor} from '../helpers/panelChangeLog';

const resolve = item => (item?.label ? item : normalizePanelChangeActor(item));

export const PanelChangeActorAvatar = ({actor, className}) => {
  const theme = useTheme();
  const {label, avatarUrl, actorType} = resolve(actor);

  if (actorType === 'client') {
    // Wrap in Avatar so AvatarGroup's border stays circular (bare SvgIcon gets a rect)
    return (
      <Avatar alt="" className={className} style={{backgroundColor: 'transparent'}}>
        <AccountCircleIcon style={{fontSize: 24, color: theme.palette.text.primary}} />
      </Avatar>
    );
  }

  return avatarUrl ? (
    <Avatar alt="" src={avatarUrl} className={className} />
  ) : (
    <Avatar alt="" className={className}>
      {label.charAt(0).toUpperCase()}
    </Avatar>
  );
};

export const PanelChangeActorFilterOption = ({classes, option, compact = false}) => (
  <Box className={classes.actorFilterOption}>
    {option.key === 'all' ? (
      <PeopleOutlineIcon
        className={compact ? classes.actorFilterEveryoneIconCompact : classes.actorFilterEveryoneIcon}
      />
    ) : (
      <PanelChangeActorAvatar
        actor={option}
        className={compact ? classes.actorFilterAvatarCompact : classes.actorFilterAvatar}
      />
    )}
    {!compact || option.key === 'all' ? (
      <span>{option.label}</span>
    ) : (
      <span className={classes.actorFilterCompactLabel}>{option.label}</span>
    )}
  </Box>
);

const PanelChangeActors = ({classes, actors}) => {
  if (!actors?.length) return null;

  if (actors.length === 1) {
    const actor = resolve(actors[0]);
    return (
      <Box className={classes.changeActor} title={actor.label}>
        <PanelChangeActorAvatar actor={actor} className={classes.changeActorAvatar} />
        <Typography variant="caption" component="span" className={classes.changeActorName} noWrap>
          {actor.label}
        </Typography>
      </Box>
    );
  }

  return (
    <Tooltip title={actors.map(item => resolve(item).label).join(', ')} arrow placement="top">
      <span className={classes.actorGroupWrap}>
        <AvatarGroup
          max={4}
          classes={{root: classes.actorGroupRoot, avatar: classes.actorGroupAvatar}}
        >
          {actors.map(item => {
            const actor = resolve(item);
            return <PanelChangeActorAvatar key={actor.key} actor={actor} />;
          })}
        </AvatarGroup>
      </span>
    </Tooltip>
  );
};

export default React.memo(PanelChangeActors);
